import { faUser } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const UserIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faUser} color={props.color} />
  )
}
